import { z } from 'zod';

export const BillingIntervalSchema = z.enum(['month', 'year']);
export type BillingInterval = z.infer<typeof BillingIntervalSchema>;
export const YEARLY_PRICE_MULTIPLIER = 10;

/**
 * Subscription plan schema.
 */
export const SubscriptionPlanSchema = z.object({
  id: z.string().describe('Unique identifier for the subscription plan.'),
  name: z.string().describe('Display name of the subscription plan.'),
  description: z.string().optional().describe('Detailed description of the subscription plan.'),
  currency: z.string().default('USD').describe('Currency code.'),
  maxTokens: z.number().int().default(0).describe('Max AI tokens allowed per subscription period'),
  isActive: z.boolean().default(true).describe('Whether the plan can be selected by new users.'),
  stripePriceId: z.string().optional().describe('Stripe Price ID associated with this plan'),
  stripeYearlyPriceId: z.string().optional()
    .describe('Stripe yearly Price ID associated with this plan'),
  displayOrder: z.number().default(0).describe('Order to display plans on the pricing page.'),
  createdAt: z.string().datetime().optional().describe('Timestamp when the plan was created.'),
  updatedAt: z.string().datetime().optional().describe('Timestamp when the plan was last updated.'),
});

export type SubscriptionPlan = z.infer<typeof SubscriptionPlanSchema>;
